import { Button, Divider, Form, Input, Select, message } from "antd";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { HiMail } from "react-icons/hi";
import { MdOutlineContentCopy } from "react-icons/md";
import { RxAvatar } from "react-icons/rx";
import { TbShare3 } from "react-icons/tb";
import CustomerLayout from "../../Components/CustomerLayout/CustomerLayout";
import styles from "./InviteFriend.module.scss";
import accepted from "./images/accepted.svg";
import invited from "./images/invited.svg";
import pending from "./images/pending.svg";
import reward from "./images/reward.svg";

const InviteFriend = () => {
    const [form] = Form.useForm();
    return (
        <CustomerLayout
            breadcrumb={[
                {
                    name: "Back to Home",
                    link: "/",
                },
                {
                    name: "Invite Friend",
                    link: "/customer/invite-friend",
                },
            ]}
        >
            <div className={styles.top_title}>
                <img
                    src="https://desi-fresh.b-cdn.net/components_static/sidebar_icons/invite-friend-active.svg"
                    alt="coupon"
                    height={40}
                />
                <h3>Invite a Friend</h3>
            </div>

            <div
                style={{
                    fontWeight: 400,
                    fontSize: "16px",
                    lineHeight: "20px",
                    marginTop: "20px",
                    marginBottom: "30px",
                }}
            >
                Invite your friends to Desi Fresh and collect coupons for shopping. You will receive a bonus for each
                friend who, from your invitation, creates an account and makes purchases for minimum 50 €. You can
                invite an unlimited number of Friends and claim an unlimited number of coupons. Details of the action in
                the regulations.
            </div>

            <div className={styles.invite_grid}>
                <div className={styles.invite_via_mail}>
                    <div className={styles.invite_via_mail_top}>
                        Share your love to reach more people to bring fresh to the doors
                    </div>

                    <div className={styles.invite_mail_content}>
                        <div className={styles.invite_mail_per}>
                            Invite your Friend to Desi Fresh. You both will get 10% discount on any purchase order
                        </div>

                        <div className={styles.invite_step_wrap}>
                            <div className={styles.invite_step}>
                                <img src={invited} alt="invited" height={25} />
                                <div>Invited</div>
                            </div>
                            <div className={styles.invite_step}>
                                <img src={accepted} alt="accepted" height={25} />
                                <div>Accepted</div>
                            </div>
                            <div className={styles.invite_step}>
                                <img src={pending} alt="pending" height={25} />
                                <div>Pending</div>
                            </div>
                            <div className={styles.invite_step}>
                                <img src={reward} alt="reward" height={25} />
                                <div>Reward Earned</div>
                            </div>
                        </div>

                        <Form
                            layout="inline"
                            form={form}
                            style={{
                                width: "100%",
                            }}
                        >
                            <Form.Item
                                name="email"
                                style={{
                                    width: "70%",
                                }}
                            >
                                <Input placeholder="user@example.com" size="large" />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" size="large">
                                    Send Invite
                                </Button>
                            </Form.Item>
                        </Form>
                        <div className={styles.invite_list}>
                            <div className={styles.invite_list_item}>
                                <div className={styles.list_item_name}>
                                    <RxAvatar size={24} />
                                    <div>Najmul Hasan</div>
                                </div>
                                <Select
                                    defaultValue="view"
                                    style={{ width: 120 }}
                                    options={[
                                        { value: "view", label: "Can View" },
                                        { value: "edit", label: "Can Edit" },
                                    ]}
                                />
                            </div>

                            <Divider
                                style={{
                                    margin: "10px 0",
                                }}
                            />

                            <div className={styles.invite_list_item}>
                                <div className={styles.list_item_name}>
                                    <RxAvatar size={24} />
                                    <div>Najmul Hasan</div>
                                </div>
                                <Select
                                    defaultValue="view"
                                    style={{ width: 120 }}
                                    options={[
                                        { value: "view", label: "Can View" },
                                        { value: "edit", label: "Can Edit" },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.or_text}>Or</div>
                <div className={styles.invite_via_social}>
                    <div className={styles.invite_via_social_top}>Invite via social media</div>
                    <div className={styles.social_content}>
                        <div className={styles.social_content_title}>
                            Invite your Friend to Desi Fresh. You both will get 10% discount on any purchase order{" "}
                        </div>

                        <div className={styles.share_t_p}>Share this purchase</div>

                        <div className={styles.social_icons}>
                            <a href="/" target="_blank">
                                <FaFacebookF size={24} />
                            </a>
                            <a href="/" target="_blank">
                                <FaLinkedinIn size={24} />
                            </a>
                            <a href="/" target="_blank">
                                <FaTwitter size={24} />
                            </a>
                            <a href="/" target="_blank">
                                <HiMail size={24} />
                            </a>
                            <a href="/" target="_blank">
                                <TbShare3 size={24} />
                            </a>
                        </div>

                        <div className={styles.share_t_p}>Or copy link</div>

                        <Input
                            size="large"
                            placeholder="https://meet.google.com/sio-jgiw-rbz"
                            readOnly
                            suffix={
                                <MdOutlineContentCopy
                                    role="button"
                                    style={{
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        navigator.clipboard.writeText("https://meet.google.com/sio-jgiw-rbz");
                                        message.success("Link Copied");
                                    }}
                                />
                            }
                        />
                    </div>
                </div>
            </div>
        </CustomerLayout>
    );
};

export default InviteFriend;
